const productInfoAccordions = Array.from(document.querySelectorAll(".product-info__accordion"));

if (productInfoAccordions.length > 0){
    productInfoAccordions.forEach((accordion) => {
        accordion.addEventListener("toggle", () => {
          if (accordion.open) {
            productInfoAccordions.forEach((otherAccordion) => {
              if (otherAccordion !== accordion) {
                otherAccordion.open = false;
              }
            });
          }
        });
    });
}
